import { Component, Input, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { HttpService } from '../services/http.service';
import { FriendService } from '../services/friend.service';
import { ToasterService } from '../services/toaster.service';
import { EventService } from '../services/event.service';
import { ProfileDirectiveModule } from '../directives/profile.directive';

@Component({
    selector: 'user-info',
    template: `
        <span [matMenuTriggerFor]="menu" (click)="getUserInfo()">
            <ng-content></ng-content>
        </span>
        <mat-menu #menu="matMenu" class="user-info-layer">
            <button mat-menu-item (click)="gotoUserHome()">
                <mat-icon class="mat-default-them mat-icon-14" svgIcon="home" aria-label="유저홈">유저홈</mat-icon>
                유저홈
            </button>
            <button mat-menu-item (click)="chanceTalk()">
                <mat-icon class="mat-default-them mat-icon-14" svgIcon="message" aria-label="찬스톡">찬스톡</mat-icon>
                찬스톡
            </button>
            <button mat-menu-item (click)="sendMessage()">
                <mat-icon class="mat-default-them mat-icon-14" svgIcon="message" aria-label="쪽지보내기">쪽지보내기</mat-icon>
                쪽지보내기
            </button>
            <button mat-menu-item (click)="addFriend()">
                <mat-icon class="mat-default-them mat-icon-14" svgIcon="supervisor" aria-label="친구추가">친구추가</mat-icon>
                친구추가
            </button>
            <button mat-menu-item (click)="claim()">
                <mat-icon class="mat-default-them mat-icon-14" svgIcon="thumb_down" aria-label="신고">신고</mat-icon>
                신고
            </button>
        </mat-menu>

    `
})
export class UserInfoComponent {
    mbId: string;
    user: any;
    @Input('mbid') set myTabObject(value: string) { // {pick: 'powerLadder', tab: 'picks' }
        if (typeof value !== 'undefined') {
            this.mbId = value;
        }
    }
    // private app: App,
    constructor(
        private http: HttpService,
        private friendService: FriendService,
        private toasterService: ToasterService,
        private eventService: EventService,
        private router: Router) {
        // this.navCtrl = app.getActiveNav();
    }
    /*tabObject: any;
    @Input('tabObject') set myTabObject(Data: any) { // {pick: 'powerLadder', tab: 'picks' }
        this.tabObject = Data;
        this.changeComponent();
    }
    */
    /**
     * 유저홈
     */
    gotoUserHome() {
        this.router.navigateByUrl('/mypage/games/' + this.user.mb_id_crypto);
    }

    /**
     * 찬스톡
     */
    chanceTalk() {
        const obj = {type: 'chanceTalkView', mb_id: this.user.mb_id, view_mode: 'direct'};
        this.eventService.broadcast('chancetalk', obj);
    }

    /**
     * 쪽지보내기
     */
    sendMessage() {
        this.router.navigate(['/mypage/note/write/', {me_recv_mb_id: this.user.mb_nick}]);
    }

    /**
     * 친구추가
     */
    addFriend() {
        const params = {mode: 'friend', flag: 'add', mb_id_crypto: this.user.mb_id_crypto};
        this.friendService.SetRelation(params, (obj: any) => {
            if (obj.result === true) {
                this.toasterService.showToaster('info', '친구로 추가되었습니다.');
            } else {
                this.toasterService.showToaster('error', obj.message);
            }
        });
    }

    getUserInfo() { // $mdOpenMenu, ev
        this.http.get({url: 'auth/userinfoById', params: {mb_id: this.mbId}}).then((res) => {
            this.user = res.user;
        });
    }

    claim() {
        const obj = {type: 'popup', component: 'claim-create', params: {w_id: this.user.mb_id, group: 'user'}};
        this.eventService.broadcast('popup', obj);
    }

}

@NgModule({
    declarations: [ UserInfoComponent ],
    imports: [ CommonModule, MatMenuModule, MatIconModule ],
    exports: [ UserInfoComponent, ProfileDirectiveModule ]

})

export class UserInfoModule { // extends HammerGestureConfig

}
